'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Styles


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _reselect = require('reselect');

var _milanoteReselect = require('../utils/milanoteReselect/milanoteReselect');

var _elementSelector = require('../element/elementSelector');

var _List = require('../list/List');

var _List2 = _interopRequireDefault(_List);

var _InboxHeader = require('./InboxHeader');

var _InboxHeader2 = _interopRequireDefault(_InboxHeader);

var _EmptyInboxPlaceholder = require('./EmptyInboxPlaceholder');

var _EmptyInboxPlaceholder2 = _interopRequireDefault(_EmptyInboxPlaceholder);

var _gridUtils = require('../utils/grid/gridUtils');

var _inboxConstants = require('./inboxConstants');

require('./Inbox.scss');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var inboxElementsSelector = (0, _milanoteReselect.createShallowSelector)(function (state, ownProps) {
    return ownProps.inboxElementIds;
}, _elementSelector.getElements, function (inboxElementIds, elements) {
    return inboxElementIds.map(function (elId) {
        return elements.get(elId);
    });
});

var mapStateToProps = (0, _reselect.createSelector)(inboxElementsSelector, function (inboxElements, elements) {
    return { inboxElements: Immutable.List(inboxElements) };
});

var Inbox = function Inbox(props) {
    var inboxElements = props.inboxElements,
        currentBoardId = props.currentBoardId,
        deselectAll = props.deselectAll,
        gridSize = props.gridSize;

    var emptyInboxPlaceholder = _react2.default.createElement(_EmptyInboxPlaceholder2.default, props);

    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('Inbox', { empty: inboxElements.size === 0 }),
            onClick: deselectAll,
            style: (0, _gridUtils.getElementStyle)(_inboxConstants.INBOX_WIDTH, gridSize) },
        _react2.default.createElement(
            'div',
            { className: 'inbox-header' },
            _react2.default.createElement(_InboxHeader2.default, props)
        ),
        _react2.default.createElement(
            'div',
            { className: 'list-scrollable' },
            _react2.default.createElement(_List2.default, _extends({}, props, {
                readyToMeasure: true,
                listId: currentBoardId,
                children: inboxElements,
                placeholderComponent: emptyInboxPlaceholder,
                inListClass: 'in-list-inbox' }))
        )
    );
};

Inbox.propTypes = {
    currentBoardId: _propTypes2.default.string,
    onDrop: _propTypes2.default.func,
    inboxElementIds: _propTypes2.default.array,
    inboxElements: _propTypes2.default.object,
    deselectAll: _propTypes2.default.func,
    gridSize: _propTypes2.default.number
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Inbox);


//////////////////
// WEBPACK FOOTER
// ./src/client/inbox/Inbox.js
// module id = 2027
// module chunks = 0